module.exports = __webpack_public_path__ + "img/banner18m.81b505e7.png";